import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatchStatus } from '../../services/match.service';

@Component({
  selector: 'app-popup-shot',
  templateUrl: './popup-shot.component.html',
  styleUrls: ['./popup-shot.component.scss']
})
export class PopupShotComponent {
  @Input() stats: any = {};

  constructor (
    private translateService: TranslateService
  ) { }

  getQuarterText (quarter) {
    let quarterText = '';
    if (quarter < MatchStatus.Overtime) {
      switch (quarter) {
        case MatchStatus.Finished: quarterText = this.translateService.instant('Full time');
                break;
        case MatchStatus.Quarter1: quarterText = this.translateService.instant('1st quarter');
                break;
        case MatchStatus.Quarter2: quarterText = this.translateService.instant('2nd quarter');
                break;
        case MatchStatus.Quarter3: quarterText = this.translateService.instant('3rd quarter');
                break;
        case MatchStatus.Quarter4: quarterText = this.translateService.instant('4th quarter');
                break;
      }
    } else {
      quarterText = `${this.translateService.instant('Overtime')} ${quarter - 9}`;
    }
    return quarterText;
  }

}
